import { render, staticRenderFns } from "./CommentFilterItem.vue?vue&type=template&id=8f80b8de&"
import script from "./CommentFilterItem.vue?vue&type=script&lang=js&"
export * from "./CommentFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports